// LanguageContext.js
import { createContext, useContext, useState, useEffect } from 'react';

// 1. Create the context
const LanguageContext = createContext();

// 2. Provider with persistent storage
export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState('es'); // default fallback

  // Load from localStorage when app initializes
  useEffect(() => {
    const savedLang = localStorage.getItem('language');
    if (savedLang) {
      setLanguageState(savedLang);
    }
  }, []);

  // Update both state and localStorage
  const setLanguage = (lang) => {
    localStorage.setItem('language', lang);
    setLanguageState(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// 3. Hook to use the context
export const useLanguage = () => useContext(LanguageContext);
